<template>
<div id="login" class="fondo" :style="{height:'100%', backgroundImage:url}">

    <v-container id="login" fluid tag="section" style=" top:25%; ">
        <v-layout align-center justify-center>

            <v-flex xs12 sm8 md4 lg4>
                <v-card flex-end class="elevation-5 input-wrapper" style=" top:-20px;  width:220px; background-color: #D2751C;
                            position: relative;
                              float: right;
                                      opacity: 0.9;
                                      filter: alpha(opacity=80);
                                      transform-origin: right top; padding-left:60px; padding-right:30px;">
                    <span class="font-weight-bold white--text caption">Acceso al Sistema</span>
                </v-card>
                <v-card class="elevation-5 pa-3" style="
                background: rgba(255,255,255, 0.95);
                ">
                    <v-card-text>
                        <div class="layout column align-left">
                            <img v-if="manifiesto==0 && sa31 ==0 && sa24==0" src="/static/logo-negro-min.png" alt="proControl" style="width:250px; opacity: 0.9;
                        filter: alpha(opacity=90);" />
                            <img v-if="manifiesto==1 && sa31==0 && sa24==0" src="https://s3.amazonaws.com/descargas.econnectpro.mx/eManifiesto-N.png" alt="proControl" style="width:250px; opacity: 0.9;
                        filter: alpha(opacity=90);" />
                            <img v-if="manifiesto==0 && sa31==1 && sa24==0" src="/static/logosa31B.png" alt="SolucionA31" style="width:250px; opacity: 0.9;
                                filter: alpha(opacity=90);" />
                            <img v-if="manifiesto==0 && sa31==0 && sa24==1 " src="/static/logosa24A.png" alt="SolucionA24" style="width:250px; opacity: 0.9;
                                filter: alpha(opacity=90);" />
                            <h1 class="flex my-4 primary--text"></h1>
                        </div>

                        <v-form>

                            <v-text-field append-icon="person" name="login" :label="label_user" type="text" hide-details backgoround-color="transparent" v-model="model.email" @input="signalChange" @keyup.enter="(model.email !== '')? validaMail() : ''" :rules="[rules.required, rules.email]" color="success" autocomplete="new-username" autofocus @focus="$event.target.select()" ref="login" class="input-group--focused"></v-text-field>
                            <input name="login" style="display:none;" autocomplete="username" />
                            <v-text-field :append-icon="iconpass" @click:append="mostrarPass" name="password" v-show="isEmailValido" @keyup.enter="(model.password !== '')? login() : ''" label="Ingrese su contraseña" :type="passwordFieldType" v-model="model.password" :rules="[rules.required]" color="success" ref="password" autocomplete="new-password" class="input-group--focused secure"></v-text-field>
                            <input name="password" style="display:none;" autocomplete="username" />
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="pl-5 pr-5">
                        <v-layout row justify-space-between>

                            <v-row>
                                <v-col sm="6" md="6" lg="6" xl="6">

                                    <v-btn v-show="isEmailValido" color="#D2751C" outlined small @click="reset" :loading="loadingReset">
                                        <v-icon small color="#D2751C">feedback</v-icon>&nbsp;Recuperar Contraseña
                                    </v-btn>
                                </v-col>
                                <v-col sm="6" md="6" lg="6" xl="6" class="text-right">
                                    <v-btn small outlined color="#D2751C" v-bind:disabled="model.email === ''" v-show="!isEmailValido" :loading="loading" @click="validaMail">
                                        <v-icon small color="#D2751C">input</v-icon> &nbsp; Continuar
                                        <v-icon small color="#D2751C">chevron_right</v-icon>
                                    </v-btn>

                                    <v-btn small outlined color="#D2751C" v-bind:disabled="model.password === ''" v-show="isEmailValido" :loading="loading" @click="login">
                                        <v-icon small>input</v-icon> &nbsp;Ingresar
                                        <v-icon color="#D2751C">chevron_right</v-icon>
                                    </v-btn>

                                </v-col>
                            </v-row>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="modal" max-width="80%" persistent scrollable>
            <v-card>
                <v-card-title>
                    <span class="headline" v-text="title"></span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <div v-html="terminos"></div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn :loading="loadingPdfTerminos" color="success" @click.native="terminosPDF()">Descargar PDF</v-btn>
                    <v-btn :loading="loadingPdfTerminosEnglish" color="blue" @click.native="terminosPDF('ingles')">Descargar PDF Inglés</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click.native="guardaAceptoTerminos">Acepto</v-btn>
                    <v-btn color="warning" @click.native="logout">No Acepto</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>

</div>
</template>

<script>
import moment from "moment";
import axios from "axios";

/*
 * make a function to use it in multiple places
 */

export default {
    components: {},

    data: () => ({
        url: "",
        label_user:"Ingrese su correo electrónico",
        verImagen: false,
        fab: false,
        fondo: "",
        manifiesto: 0,
        sa31: 0,
        sa24: 0,
        terminos: "",
        colortema: false,
        id_termino: 0,
        title: "",
        modal: false,
        respuestalogin: false,
        loading: false,
        loadingReset: false,
        loadingPdfTerminos: false,
        loadingPdfTerminosEnglish: false,
        isEmailValido: false,
        passwordFieldType: "password",
        iconpass: "fa-eye",
        url: "",
        rules: {
            required: value => !!value || "El campo no puede ir vacio",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            }
        },
        model: {
            email: "",
            password: ""
        }
    }),

    created: function () {

    },

    mounted: function () {

        if (this.$route.query.emanifiesto === null) {
            this.$local_storage.set("login", 1);
            this.manifiesto = 1;
            this.sa31 = 0;
            this.sa24 = 0;
        }
        if (this.$route.query.sa31 === null) {
            this.manifiesto = 0;
            this.$local_storage.set("login", 2);
            this.sa31 = 1;
            this.sa24 = 0;
        }
        if (this.$route.query.sa24 === null) {
            this.manifiesto = 0;
            this.$local_storage.set("login", 3);
            this.sa31 = 0;
            this.sa24 = 1;
            this.label_user = "Ingrese su usuario";
        }
        if (this.$route.query.emanifiesto === undefined && this.$route.query.sa31 === undefined && this.$route.query.sa24 === undefined ) {
            this.manifiesto = 0;
            this.sa31 = 0;
            this.sa24 = 0;
            this.$local_storage.set("login", 0);
        }

        if (this.sa24 == 0 &&  this.manifiesto == 0 && this.sa31 == 0 ) {
            this.url = `url('https://s3.amazonaws.com/descargas.econnectpro.mx/fondo.png')`;
        }
        if(this.sa24 == 0 &&  this.sa31 == 0 && this.manifiesto == 1 ){
            this.url = `url('https://s3.amazonaws.com/descargas.econnectpro.mx/fondoeManifiesto.gif')`;
        }
        if( this.sa24 == 0 &&  this.sa31 == 1 && this.manifiesto == 0 ){
            this.url = `url('https://s3.amazonaws.com/descargas.econnectpro.mx/fondosa31.png')`;
        }
        if( this.sa31 == 0 &&  this.sa24 == 1 && this.manifiesto == 0  ){
            this.url = `url('https://s3.amazonaws.com/descargas.econnectpro.mx/fondosa24.png')`;
        }
    },

    methods: {
        mostrarPass: function (evt) {
            this.passwordFieldType =
                this.passwordFieldType === "password" ? "text" : "password";
            this.iconpass =
                this.passwordFieldType === "password" ? "fa-eye" : "fa-eye-slash";
        },

        signalChange: function (evt) {
            this.$emit("change", evt);
            this.isEmailValido = false;
        },
        reset() {
            var self = this;
            this.$swal({
                type: "info",
                title: "Solicitud de cambio de contraseña",
                text: "¿Está seguro que desea realizar la solicitud, se le enviará un correo eléctronico donde tendrá que confirmar el cambio?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                var data = {
                    email: self.model.email,
                    sistema: this.$sistema,
                    headers: {
                        "Content-type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    }
                };
                if (result.value) {

                    var url = self.$hostname + "usuarios/reset_password/";
                    var self2 = self;
                    this.loadingReset = true;
                    axios
                        .post(url, data)
                        .then(function (response) {
                            self.$swal({
                                type: "succcess",
                                title: "Operación Exitosa",
                                text: "La solicitud fue creada con exito, en unos minutos verifique su bandeja de entrada, y pueda continuar con el proceso",
                                footer: ""
                            });
                        })
                        .catch(function (error) {
                            var msg =
                                "Ocurrió un error al crear la solicitud intente nuevamente más tarde, en caso contrario comuniquese con el administrador del sistema.";
                            self.$swal({
                                type: "error",
                                title: "Operación no concluida",
                                text: msg,
                                footer: ""
                            });
                        }).then(() => {
                            this.loadingReset = false;
                        });
                }
                // this.$router.push('/pass');
            });
        },
        validaMail() {
            var url = this.$hostname + "usuarios/verifica_email/";
            var datos = {
                email: this.model.email,
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            };
            var self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(url, datos)
                .then(function (response) {

                    self.isEmailValido = true;
                    setTimeout(function () {
                        self.$refs.password.focus();
                    }, 10);

                })
                .catch(function (error) {
                    console.log(error);
                    var msg = "Ocurrió un error al verificar el usuario";

                    if (error.response) {
                        if (error.response.data.mensaje) {
                            msg = error.response.data.mensaje;
                        } else {
                            if (error.response.data.email != null)
                                msg = error.response.data.email[0];
                        }
                    }
                    self.$swal({
                        type: "error",
                        title: msg,
                        text: "",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
            // this.$router.push('/pass');
        },
        login: async function () {
            try {
                var data = {
                    username: this.model.email,
                    password: this.model.password,
                    sistema: this.$sistema,
                };

                var url = this.$hostname + "usuarios/login/";
                var self = this;
                self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                await axios
                    .post(url, data)
                    .then(function (response) {
                        if (response.data.mensaje != null) {
                            self.respuestalogin = response.data.mensaje;
                            var tipoUsuario = response.data.mensaje.tipo_usuario;
                            if (response.data.mensaje.terminos == false &&
                                (tipoUsuario == "Cliente" || tipoUsuario == "Grupo" || tipoUsuario == "Pagos" || tipoUsuario == "Asuntos Legales")) {
                                self.verTerminos();
                            } else {
                                self.iniciar();
                            }
                        } else {
                            self.$root.$dialogLoader.hide();
                        }
                    })
                    .catch(function (error) {
                        self.$root.$dialogLoader.hide();
                        var msg = "";
                        //console.log(error);
                        if (error.response != null) {
                            if (error.response.data.mensaje) {
                                msg = error.response.data.mensaje;
                            } else {
                                if (error.response.data.email)
                                    msg += error.response.data.email[0];
                                if (error.response.data.password)
                                    msg += error.response.data.password[0];
                            }
                        } else {
                            msg = 'Ocurrió un error al iniciar sesión. Favor de comunicarse con soporte.';
                        }

                        if (error.response.status == 406) { //Ocurrió una excepción y hay que dejar al usuario con sesionactiva=0
                            var urlLogout = self.$hostname + "usuarios/logout_by_mail/";
                            axios.post(urlLogout, {
                                    usuario: self.model.email
                                })
                                .then(function (response) {}).catch(function (error) {}).then(() => {
                                    self.$local_storage.set("token", "");
                                    self.$local_storage.set("id_usuario", 0);
                                    self.$local_storage.set("tipo_usuario", "guest");
                                    self.$user.set({
                                        role: "guest"
                                    });
                                    self.$user.set({
                                        id_cliente: 0
                                    });
                                });
                        }

                        self.$swal({
                            type: "error",
                            title: "Operación No Permitida",
                            text: msg,
                            footer: ""
                        });
                    });
            } catch (error) {
                this.$swal({
                    type: "error",
                    title: "Operación No Permitida",
                    text: 'Ocurrió un error al iniciar sesión. Favor de intentar nuevamente',
                    footer: ""
                });
            }

        },
        inicializapermisos: async function (estatus) {
            //  var result = [];
            var data = {
                sistema: this.$sistema,
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "cache-control": "no-cache"
                }
            };

            var url = this.$hostname + "sistemas/get_permisos_sistema/";
            let self = this;
            await axios
                .post(url, data)
                .then(function (response) {
                    response.data.forEach(function (element) {
                        self.$local_storage.set(element.clave, estatus);
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        permisoscliente: async function (id_cliente) {
            var data = {
                sistema: this.$sistema,
                cliente: id_cliente,
                id_perfil: 0,
            };

            var url = this.$hostname + "perfiles/get_permisos_perfil/";
            let self = this;
           
            await axios
                .post(url, data)
                .then(function (response) {
                    response.data.forEach(function (element) {
                        self.$local_storage.set(element.clave, 100);
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            for (var i = 1; i < 19; i++) {
                self.$local_storage.set("Modulo" + i, 0);
            }

            data = {
                cliente: id_cliente
            }
            axios
                .post(self.$hostname + "clientes-sistemas/list_modulos_cliente/", data)
                .then(response => {
                    response.data.forEach(function (m) {
                        self.$local_storage.set("Modulo" + m.modulo, 100);
                    });
                    if (response.data.length == 1 && self.$local_storage.get("Modulo13") == 100) {
                        self.$local_storage.set("soloCartaPorte", 100);
                        this.mostrarmenu(true);
                    } else {
                        self.$local_storage.set("soloCartaPorte", 0);
                    }

                    

                    if (response.data.length == 1 && self.$local_storage.get("Modulo15") == 100) {
                        self.$local_storage.set("soloSA31", 100);
                        self.$store.state.sa31 = true;
                        this.mostrarmenu(true);
                    } 
                    if (response.data.length == 1 && self.$local_storage.get("Modulo16") == 100) {
                        self.$local_storage.set("soloSA31", 100);
                        self.$store.state.sa31 = true;
                        this.mostrarmenu(true);
                    } 
                    if (response.data.length == 1 && self.$local_storage.get("Modulo18") == 100) {
                        self.$local_storage.set("soloSA24", 100);
                        self.$store.state.sa24 = true;
                        this.mostrarmenu(true);
                    } 
                    if (response.data.length == 2 && self.$local_storage.get("Modulo15") == 100 && self.$local_storage.get("Modulo16") == 100) {
                                    self.$local_storage.set("soloSA31", 100);
                                    self.$store.state.sa31 = true;
                                    this.mostrarmenu(true);
                     } 
                    
                    
                })
                .catch(error => {
                    console.log(error);
                });
        },
        permisosgrupo: async function (id_perfil) {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                id_perfil: id_perfil,
                cliente: 0,
                sistema: 1
            }
            await axios
                .post(this.$hostname + "perfiles/get_permisos_perfil/", data)
                .then(response => {

                    var arr = response.data;
                    console.log("paso6");
                    for (var i in arr) {
                        if (arr[i].activo == 1) {
                            let clave = arr[i].clave;
                            self.$local_storage.set(clave, 100);
                        }

                    }

                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los permisos.",
                        footer: ""
                    });
                });
        },

        permisosusuario: async function (id_cliente, perfil) {
            var data = {
                sistema: this.$sistema,
                cliente: id_cliente,
                id_perfil: 0,
            };

            var url = this.$hostname + "perfiles/get_permisos_perfil/";
            let self = this;
            let permisos_cliente = [];
            await axios
                .post(url, data)
                .then(function (response) {
                    response.data.forEach(function (element) {
                        permisos_cliente.push(element.clave);
                    });
                    console.log(perfil);
                    // carga los permisos del usaurio
                    perfil.forEach(function (element) {
                        if (permisos_cliente.includes(element.clave))
                            self.$local_storage.set(element.clave, "100");
                    });
                    for (var i = 1; i < 19; i++) {
                            self.$local_storage.set("Modulo" + i, 0);
                        }
                        console.log(self.respuestalogin);
                        data = {
                            perfil: self.respuestalogin.perfil_grupo
                        }
                        axios
                            .post(self.$hostname + "perfiles/get_modulos_perfil/", data)
                            .then(response => {
                                console.log(response.data);
                                response.data.forEach(function (m) {

                                    self.$local_storage.set("Modulo" + m.id_modulo, 0);
                                    if(m.acceso == 1)
                                        self.$local_storage.set("Modulo" + m.id_modulo, 100);

                                });
                                response.data = response.data.filter(i => i.acceso == 1 );

                                if (response.data.length == 1 && self.$local_storage.get("Modulo13") == 100) {
                                    self.$local_storage.set("soloCartaPorte", 100);
                                    self.mostrarmenu(true);
                                } else {
                                    self.$local_storage.set("soloCartaPorte", 0);
                                    self.mostrarmenu(true);
                                }

                                

                                if (response.data.length == 1 && self.$local_storage.get("Modulo15") == 100) {
                                    self.$local_storage.set("soloSA31", 100);
                                    self.$store.state.sa31 = true;
                                    self.mostrarmenu(true);
                                } 
                                if (response.data.length == 1 && self.$local_storage.get("Modulo16") == 100) {
                                    self.$local_storage.set("soloSA31", 100);
                                    self.$store.state.sa31 = true;
                                    self.mostrarmenu(true);
                                } 
                                if (response.data.length == 1 && self.$local_storage.get("Modulo18") == 100) {
                                    self.$local_storage.set("soloSA24", 100);
                                    self.$store.state.sa24 = true;
                                    self.mostrarmenu(true);
                                } 
                                if (response.data.length == 2 && self.$local_storage.get("Modulo15") == 100 && self.$local_storage.get("Modulo16") == 100) {
                                    self.$local_storage.set("soloSA31", 100);
                                    self.$store.state.sa31 = true;
                                    self.mostrarmenu(true);
                                } 
                               
                                
                                
                            })
                            .catch(error => {
                                console.log(error);
                            });

                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        iniciar: async function () {

            var self = this;
            var cliente = self.respuestalogin.cliente;
            self.$local_storage.set("subtipo_usuario", "");
            self.$local_storage.set("referencia_usuario", "");
            self.$local_storage.set("consignatario_usuario", "");
            self.$local_storage.set("trafico", 0);
            self.$local_storage.set("costing", 0);
            self.$local_storage.set('emanifiesto', 0);
            self.$local_storage.set('carta_porte', 0);
            self.$local_storage.set('verSA31',0);
            self.$local_storage.set('verSA24',0);
            self.$local_storage.set("es_transportista", 0);
            self.$local_storage.set("es_agente", 0);
            self.$local_storage.set("id_grupo", 0);
            self.$local_storage.set("soloSA31", 0);
            self.$local_storage.set("soloSA24", 0);
            self.$local_storage.set('sa31', 0);
            self.$local_storage.set('sa24', 0);
            self.$local_storage.set("soloCartaPorte", 0);

            var data = {
                email: self.respuestalogin.username,
            };
            await axios
                .post(self.$hostname + "avatar/get_avatar/", data)
                .then(res => {
                    if (typeof res.data !== "false") {
                        self.$local_storage.set("avatar", res.data.avatar);
                    }
                })
                .catch(err => {
                    // console.log(err);
                    self.$local_storage.set("avatar", "undefined");
                });

            if (cliente.id_cliente > 0) {
                self.$local_storage.set("rfc", cliente.rfc);
                self.$local_storage.set("id_cliente", cliente.id_cliente);
                self.$local_storage.set("dias_cliente", cliente.dias_cliente);
                self.$user.set({
                    id_cliente: cliente.id_cliente
                });
                self.$local_storage.set("razon", cliente.razon_social);
                self.$local_storage.set("varios_clientes", 0);
                self.$store.state.id_cliente = cliente.id_cliente;

                if (self.respuestalogin.subtipo_usuario != null)
                    self.$local_storage.set("subtipo_usuario", self.respuestalogin.subtipo_usuario);

                if (self.respuestalogin.referencia_usuario != null && self.respuestalogin.subtipo_usuario == "clientes_referencias")
                    self.$local_storage.set("referencia_usuario", self.respuestalogin.referencia_usuario);

            }
            self.$user.set({
                role: self.respuestalogin.tipo_usuario
            });

            self.$local_storage.set("panel_grupo", 0);
            self.$local_storage.set("token", self.respuestalogin.token);
            self.$local_storage.set("id_usuario", self.respuestalogin.id);

            if (self.respuestalogin.grupo == null)
                self.$local_storage.set("id_grupo", 0);
            else
                self.$local_storage.set("id_grupo", self.respuestalogin.grupo);

            self.$local_storage.set("tipo_usuario", self.respuestalogin.tipo_usuario);
            self.$local_storage.set("nombre_usuario", self.respuestalogin.nombre);
            self.$local_storage.set("email", self.respuestalogin.username);
            self.$local_storage.set("id_perfil", 0);
            self.$local_storage.set("perfil_grupo", 0);

            if (self.respuestalogin.grupo > 0)
                await self.getGrupo(self.respuestalogin.grupo);

            await self.verAvisos(self.respuestalogin.id, self.respuestalogin.tipo_usuario);
            await self.getTigies();

            await self.inicializapermisos("0");

            if (cliente.id_cliente > 0) {
                if (self.respuestalogin.perfil.length > 0) {
                    self.$local_storage.set("id_perfil", 1);
                    await self.permisosusuario(cliente.id_cliente, self.respuestalogin.perfil);
                } else {
                    self.$local_storage.set("id_perfil", 0);
                    await self.permisoscliente(cliente.id_cliente);
                }
                self.$local_storage.set("perfil_grupo", self.respuestalogin.perfil_grupo);

                if (self.$local_storage.get("soloCartaPorte") == 100)
                    self.$router.replace("/index").catch(() => {});

                if (self.$local_storage.get("soloSA31") == 100)
                    self.$router.replace("/indexsa31").catch(() => {});
               
                if (self.$local_storage.get("soloSA24") == 100)
                    self.$router.replace("/indexsa24").catch(() => {});

                if (self.$local_storage.get("Modulo14") == 100)
                    self.$router.replace("/indexAAC").catch(() => {});

                if (self.$local_storage.get("Modulo18") == 100 && (self.$local_storage.get("Modulo17") == 100 || self.$local_storage.get("Modulo16") == 100) && self.$local_storage.get("Modulo6") != 100  )
                    self.$router.replace("/vacio").catch(() => {});

                //cuando sea consignatario trafico/reporte_embarques
                if (self.respuestalogin.perfil_grupo == 43) {
                    self.$router.replace("/trafico/reporte_embarques").catch(() => {});
                    await self.mostrarmenu(true);
                } else {

                    //si solo tiene ds mandarlo a bitacora
                    if (self.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100 &&
                        self.$local_storage.get("VUCEM.Pedimento.consulta.cove") == 100) {
                        self.$router.replace("/home").catch(() => {});
                    } else {
                        if (self.$local_storage.get("DATA.STAGE.cargazip") == 100)
                            self.$router.replace("/datastage/bitacorazip").catch(() => {});
                        else if (self.$local_storage.get("VUCEM.Transmision.ver.coves") == 100)
                            self.$router.replace("/transmision/covedetalles").catch(() => {});
                        else if (self.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100)
                            self.$router.replace("/reportes/consultar_pedimentos_ws").catch(() => {});
                    }
                    self.mostrarmenu(true);
                }


            } else {
                self.$local_storage.set("rfc", "");
                self.$local_storage.set("razon", "");
                self.$local_storage.set("id_cliente", 0);
                self.$local_storage.set("dias_cliente", "");
                self.$local_storage.set("perfil_grupo", 0);
                self.$local_storage.set("subtipo_usuario", "");
                self.$local_storage.set("referencia_usuario", "");
                self.$local_storage.set("carta_porte", 0);
                self.$local_storage.set("grupo", self.respuestalogin.grupo);

                if (self.respuestalogin.grupo == null)
                    self.$local_storage.set("id_grupo", 0);
                else
                    self.$local_storage.set("id_grupo", self.respuestalogin.grupo);

                self.$user.set({
                    id_cliente: 0
                });

                if (cliente == -1) self.$local_storage.set("varios_clientes", 1);

                if (self.respuestalogin.tipo_usuario == "Pagos" || self.respuestalogin.tipo_usuario == "Asuntos Legales") {
                    self.$local_storage.set("varios_clientes", 0);
                    self.$router.replace("/index").catch(() => {});
                }
                if ((self.respuestalogin.tipo_usuario == "Grupo") || self.respuestalogin.tipo_usuario == "Soporte" || cliente == -1) {

                    if (self.respuestalogin.perfil_grupo != null) {
                        self.$local_storage.set("perfil_grupo", self.respuestalogin.perfil_grupo);
                        await self.permisosgrupo(self.respuestalogin.perfil_grupo);

                    }

                    self.$local_storage.set("varios_clientes", 1);

                    if (self.$local_storage.get("panel_grupo") == 1)
                        this.$router.replace("/admin").catch(() => {});
                    else if (self.$local_storage.get("es_transportista") == 1)
                        self.$router.replace("/indext").catch(() => {});
                    else if (self.$local_storage.get("es_agente") == 1)
                        this.$router.replace("/indexAA").catch(() => {});
                    else if (self.manifiesto == 1) //Cuando un grupo no transportista entra por el login de emanifiesto (https://econnectpro.mx/?emanifiesto)
                        self.$router.replace("/indext").catch(() => {});
                    else if (self.$local_storage.get("soloSA31") == 100)
                        self.$router.replace("/indexsa31").catch(() => {});
                    else if (self.$local_storage.get("soloSA24") == 100)
                        self.$router.replace("/indexsa24").catch(() => {});
                    else
                        self.$router.replace("/listaclientes").catch(() => {});
                }

                if (self.respuestalogin.tipo_usuario == "Super Usuario") {
                    await self.inicializapermisos("100");
                    self.$store.state.id_cliente = -1;
                    self.$local_storage.set("varios_clientes", 1);
                    self.$router.replace("/admin").catch(() => {});
                }
                self.mostrarmenu(true);

                self.getMarquees();

            }
            self.$root.$dialogLoader.hide();
        },

        mostrarmenu: function (val) {
            //Se actualiza la variable store.state.datetime para forzar a recargar el componente de AppBar.vue
            //Esta variable se manda llamar en el archivo App.vue
            this.$store.state.datetime = moment(new Date()).format("x"); //Unix timestamp
        },

        registerurl() {
            this.$router.push("/usuarios/registro").catch(() => {});
        },
        ver() {
            this.$swal({
                "width": "50em",
                "html": ' <img  src="https://s3.amazonaws.com/descargas.econnectpro.mx/notificaciones/0.8843191653987947_2023 Linea de Captura.png"  style="max-width:500px" />'
            });
        },
        /* Muestra las notificaciones con mostrar_aviso=1 que no han sido leidas (estatus=0) */
        verAvisos: function (id_usuario, tipoUsuario) {
            try {
                axios
                    .post(this.$hostname + "notificaciones/list_notificaciones/", {
                        usuario: id_usuario
                    })
                    .then(response => {
                        let notificaciones = response.data.filter(notificacion => {
                            if (notificacion.mostrar_aviso != undefined) {
                                return notificacion.mostrar_aviso == 1 && notificacion.estatus == 0;
                            }
                        });

                        for (var k in notificaciones) {
                            let item = notificaciones[k];
                            var mensaje = item.mensaje;
                            var footer = "";
                            var fileadjunto = "";
                            try {
                                var json = JSON.parse(mensaje);
                                if (json.texto != undefined)
                                    mensaje = json.texto;
                                if (json.file != undefined && json.file != "") {
                                    footer = 'Ver archivo adjunto';
                                    fileadjunto = json.file;
                                }
                            } catch (e) {}

                            //Si son varias notificaciones o tiene archivo le damos la opcion de enviarloa  notificaciones o descargar file
                            if (notificaciones.length > 1) {

                                footer = 'Ver ' + notificaciones.length + ' notificaciones más'
                                footer =  ""
                                if (item.tipo != 'IMAGEN') {
                                    this.$swal({
                                        type: "info",
                                        title: item.titulo,
                                        text: mensaje,
                                        footer: "",
                                        confirmButtonColor: "#1B5E20",
                                        confirmButtonText: "Aceptar"
                                    }).then(result => {
                                        this.markRead(item, id_usuario, tipoUsuario);
                                        if (result.value) {
                                          //  this.$router.push('/notificaciones').catch(() => {});
                                         // this.verAvisos (id_usuario, tipoUsuario);
                                        }
                                    
                                });
                            
                                } else {
                                            this.$swal({
                                                "width": "80em",
                                                "confirmButtonText": "Aceptar",
                                                "html": ' <img  src="https://s3.amazonaws.com/descargas.econnectpro.mx/' + fileadjunto + '"  style="max-width:100%" />'
                                            }).then(result => {
                                                this.markRead(item, id_usuario, tipoUsuario);
                                                if (result.value) {
                                                    //  this.$router.push('/notificaciones').catch(() => {});
                                                  //  this.verAvisos (id_usuario, tipoUsuario);
                                                }
                                            });
                                        }
                            } else if (footer != "" && fileadjunto != "") {
                                if (item.tipo != 'IMAGEN') {
                                    this.$swal({
                                        type: "info",
                                        title: item.titulo,
                                        text: mensaje,
                                        footer: "",
                                        confirmButtonColor: "#1B5E20",
                                        confirmButtonText: "Aceptar"
                                    }).then(result => {
                                        this.markRead(item, id_usuario, tipoUsuario);
                                       // if (result.value) {
                                         //   this.downloadFile(fileadjunto);
                                       // }
                                    });
                                } else {
                                    this.$swal({
                                        "width": "80em",
                                        "confirmButtonText": "Aceptar",
                                        "html": ' <img  src="https://s3.amazonaws.com/descargas.econnectpro.mx/' + fileadjunto + '"  style="max-width:100%" />'
                                    }).then(result => {
                                        this.markRead(item, id_usuario, tipoUsuario);

                                    });
                                }
                            } else { //Si es solo una notificacion se muestra normal
                                this.$swal({
                                    type: "info",
                                    title: item.titulo,
                                    text: mensaje,
                                    footer: "",
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "Aceptar",
                                }).then(result => {
                                    if (result.value) {
                                        this.markRead(item, id_usuario, tipoUsuario);
                                    }
                                });
                            }
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            } catch (error) {
                console.log(error);
            }

        },
        markRead: function (item, id_usuario, tipoUsuario) {
            var id_notificacion = item.id_notificacion;
            var markAsRead = 0;
        /*     if (tipoUsuario == "Super Usuario" || tipoUsuario == "Soporte" || tipoUsuario == "Grupo") {
                markAsRead = 1;
            } else if (item.aviso_rfc == 0) { //Si el aviso no fue enviado seleccionado RFC entonces si lo puede marcar como leído
                markAsRead = 1;
            } */
            markAsRead = 1;
            if (markAsRead == 1) {
                axios.put(this.$hostname + "notificaciones/mark_as_read/", {
                        usuario: id_usuario,
                        id_notificacion: id_notificacion
                    }).then(response => {
                        this.verAvisos (id_usuario, tipoUsuario)
                    })
                    .catch(error => {});
            }

        },
        verTerminos: function () {
            axios
                .get(this.$hostname + "terminos/get_ultimo/")
                .then(res => {
                    if (res.data[0].contenido) {
                        this.terminos = res.data[0].contenido;
                        this.id_termino = res.data[0].id_termino;
                        this.title = "Términos y Condiciones";
                        this.modal = true;
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se han configurado Términos y Condiciones.",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los Términos y Condiciones.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getMarquees: function () {
            axios
                .get(this.$hostname + "catalogos/notificaciones_marquee/")
                .then(response => {
                    let avisos = response.data.filter(aviso => aviso.activo == 1 && aviso.tipo == 1);
                    let texto = "";

                    for (let i = 0; i < avisos.length; i++)
                        this.$toast.info(avisos[i].texto, "", {
                            balloon: true,
                            close: true,
                            position: "bottomLeft",
                            timeout: null,
                            animateInside: true,
                            drag: true,
                            transitionIn: 'flipInX',
                            transitionOut: 'flipOutX',
                            pauseOnHover: true
                        })
                })
                .catch(error => {
                    console.log("Ocurrió un error al obtener los avisos.");
                });
        },
        getTigies: function () {
            var f = new Date();

            let y = f.getFullYear();
            let m = f.getMonth() + 1;
            let d = f.getDate();

            if (m < 10)
                m = '0' + m;
            else
                m='' + m;

            if (d < 10)
                d = '0' + d;
            else
                d= '' + d

            let hoy = y + '/' + m + '/' + d;

            let self = this; 
          //  fetch("https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bitacora&filterBy=Fecha%20BETWEEN%20'" + hoy + "'%20and%20'" + hoy + "'&orderBy=&startIndex=1&endIndex=50&formatResult=&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=")
            fetch("https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bitacora&filterBy=Fecha%20BETWEEN%20'" + hoy + "'%20and%20'" + hoy + "'&orderBy=&startIndex=1&endIndex=50&formatResult=&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=")
        //  fetch("https://hts.gsmartcode.com/api/service?cmd=getTable&tableName=bitacora&filterBy=Fecha%20BETWEEN%20'2024/08/28'%20and%20'2024/08/28'&orderBy=&startIndex=1&endIndex=50&formatResult=&apiKey=40A563F8D7864948A4EC6FDB3735F963&maxSizeperValue=")
      
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    
                  //  if(Array.isArray(data)){
                        if(data['error'] != "undefined"){
                        console.log(Array.isArray(data));
                        data.forEach(function (p) {
                            
                        let fecha = self.arreglaMes(p.Fecha.substring(0, p.Fecha.length - 8));
                        let link = "<a target='_blank' title='Visualizar PDF' href='https://hts.gsmartcode.com/docs/bitacora/" + p.SYSID + ".pdf'> <i class='v-icon notranslate mdi mdi-file' /></a>";
                        let mas = "<br/><a href='/DOF'>Ver Mas..</a>"
                        if (p.Publicacion != "Sin publicación en el DOF el dia hoy, relacionada con la TIGIE."){
                            self.$toast.info(p.Publicacion + mas, "DOF - " + fecha + " - Secretaría " + p.Secretaria + link, {
                                balloon: true,
                                close: true,
                                position: "bottomLeft",
                                timeout: 10000,
                                animateInside: true,
                                drag: true,
                                transitionIn: 'flipInX',
                                transitionOut: 'flipOutX',
                                pauseOnHover: true
                            });
                            
                        }
                    });
                }

                }).catch(function (error) {
                    console.log(error);
                });

        },
        arreglaMes(mes) {
            let r = "";
            r = mes.replace('Jan', 'Ene');
            r = r.replace('Apr', 'Abr');
            r = r.replace('Aug', 'Ago');
            r = r.replace('Dec', 'Dic');

            return r;
        },
        guardaAceptoTerminos: function () {
            var data = {
                id_termino: this.id_termino,
                id_usuario: this.respuestalogin.id,
                fecha: moment(new Date()).format("YYYY-MM-DD")
            };
            axios
                .post(this.$hostname + "usuarios/save_usuario_terminos/", data)
                .then(res => {
                    if (res.data.mensaje) {
                        this.iniciar();
                    } else {
                        this.logout();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se guardó la aceptación de los términos",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.logout();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al guardar la aceptación de los términos",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        terminosPDF: function (opcion = "espanol") {
            if (opcion == "espanol") {
                this.loadingPdfTerminos = true;
                var datos = {
                    id: 'Terminos.pdf',
                    bucket: 'descargas.econnectpro.mx'
                }
            } else {
                this.loadingPdfTerminosEnglish = true;
                var datos = {
                    id: 'Terminos_English.pdf',
                    bucket: 'descargas.econnectpro.mx'
                }
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        //a.download = name[name.length - 1];
                        a.click();
                        a.parentNode.removeChild(a);
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el PDF de los términos";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.loadingPdfTerminos = false;
                    this.loadingPdfTerminosEnglish = false;
                });
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getGrupo: async function (id_grupo) {
            var self = this;
            await axios
                .get(this.$hostname + "grupos/" + id_grupo + "/")
                .then(response => {
                    self.$local_storage.set("panel_grupo", response.data.panel);
                    self.$local_storage.set("es_transportista", response.data.es_transportista);
                    self.$local_storage.set("es_agente", response.data.es_agente);
                    self.$local_storage.set("rfc_grupo", response.data.rfc);
                    self.$local_storage.set("nombre_grupo", response.data.nombre);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        logout() {
            this.modal = false;
            var data = {
                usuario: this.respuestalogin.id,
                sistema: this.$sistema
            };

            var url = this.$hostname + "usuarios/logout/";

            var self = this;
            axios
                .post(url, data)
                .then(function (response) {
                    self.$local_storage.set("token", "");
                    self.$local_storage.set("id_usuario", 0);
                    self.$local_storage.set("cambio_cliente", true);
                    self.$user.set({
                        role: "guest"
                    });
                    self.$router.push("/").catch(() => {});
                    self.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "La sesión se cerró correctamente",
                        footer: '',
                    });
                })
                .catch(function (error) {

                    self.$swal({
                        type: "error",
                        title: "Operación no Permitida",
                        text: "Ocurrió un error al cerrar la sesión",
                        footer: ""
                    });
                });
        }
    }
};
</script>

<style lang="css" scoped>
#login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;

}

.fondo {
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-size: cover;
    height: 100%;
}
</style>
